import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const KEY = "immistop_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(!localStorage.getItem(KEY)), 1800);
    return () => clearTimeout(t);
  }, []);
  const decide = (v) => { localStorage.setItem(KEY, v); setShow(false); };
  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 40, opacity: 0 }} transition={{ duration: 0.7, ease: [0.2, 0.7, 0.2, 1] }} className="fixed bottom-5 left-5 right-24 z-[45] max-w-md border border-gold/30 bg-navy p-6 text-ivory shadow-2xl sm:left-8 sm:right-auto" data-testid="cookie-banner" role="dialog" aria-label="Cookie consent">
          <p className="font-serif text-xl">A note on cookies</p>
          <p className="mt-2 text-[13px] leading-relaxed text-ivory/80">We use essential cookies to run this site and optional analytics to improve it. Read our <Link to="/privacy" className="text-gold underline-offset-4 hover:underline">Privacy Policy</Link>.</p>
          <div className="mt-5 flex gap-3">
            <button type="button" onClick={() => decide("all")} className="btn-gold !px-5 !py-2.5" data-testid="cookie-accept-btn"><span>Accept</span></button>
            <button type="button" onClick={() => decide("essential")} className="btn-outline-light !px-5 !py-2.5" data-testid="cookie-essential-btn">Essential only</button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
